// ----------------------------------------------------------------------------
// Выбирает через какую соцсеть авторизуемся
// ----------------------------------------------------------------------------



import OpenAuth from "./open-auth.js";



const auth_chooseOpenSocial = (event) => {
    event.preventDefault();

    const button = event.currentTarget;
    const dataService = button?.dataset.service;

    if (!dataService) return;

    // Конфиг размеров окон для соцсетей
    const windowSizes = {
        facebook:  { w: 800, h: 520 },
        twitter:   { w: 650, h: 520 },
        vkontakte: { w: 670, h: 420 }
    };

    const size = windowSizes[dataService];

    if (size) {
        OpenAuth(button, size.w, size.h);
    }

    return false;
}

export default auth_chooseOpenSocial;